Vendd.Scripts.load(function () {
    'use strict';

    var $wrappers = $('.x-lazy-product-list');

    if ($wrappers.length < 1)
        return;

    var currentitemid = LhApp.Context.Item.Id !== undefined && LhApp.Context.Item.Id > 0 ? LhApp.Context.Item.Id : 0;
    var lazyLoadPrices = $('.list-lazy-load-prices').first().text().toLowerCase().trim() === "true";
    var customPrices = false;
    var skuQueryString = $('.x-product-details').length > 0 ? getQueryStringValueByName('skuid').length > 0 : false;

    $.each($wrappers, function (i, wrpr) {
        var $this = $(wrpr);

        wrpr.model = null;


        //DO NOT ADD NESTED PROPERTIES. THIS PAYLOAD WILL BE SUBMITTED THROUGH URL.
        var configuration = {
            configCode: $this.data("code"),
            templateCode: $this.data("template"),
            entityCode: $this.data("entity"),
            itemId: currentitemid,
            refreshInterval: $this.data("refresh-interval") === undefined ? 0 : parseInt($this.data("refresh-interval")),
            allowLazyloadCdnCaching: $this.data("allow-lazyload-cdn-caching") ? true : false,
            nodeId: $this.data("nodeid"),
            nodePath: $this.data("nodepath"),
        };

        var url = "", hasUrlParameters = false;

        if ($('.x-product-details').length > 0 && ($this.data("price-from-multiplier") || $this.data("price-to-multiplier") || $this.data("price-from-addend") || $this.data("price-to-addend"))) {
            hasUrlParameters = true;
        }

        if ($('.x-product-details').length > 0 && $('.x-product-details').data('selected-color-id') > 0 && $this.data("photodimensiondependent")) {
            configuration.photoDimensionId = $('.x-product-details').data('selected-color-id');
        }

        wrpr.loading = function loading(loading) {
            if (loading) {
                $this.addClass('x-loading');
            } else {
                $this.removeClass('x-loading');
            }
        };

        wrpr.updateUrlParameters = function updateUrlParameters(productModel) {
            //get data attributes
            var priceFromMultiplier = $this.data("price-from-multiplier") ? parseFloat($this.data("price-from-multiplier")) : 1;
            var priceToMultiplier = $this.data("price-to-multiplier") ? parseFloat($this.data("price-to-multiplier")) : 1;
            var priceFromAddend = $this.data("price-from-addend") ? parseFloat($this.data("price-from-addend")) : 0;
            var priceToAddend = $this.data("price-to-addend") ? parseFloat($this.data("price-to-addend")) : 0;

            //get current product price
            var productPrice;

            if (productModel) {
                productPrice = productModel.Prices.UnitPriceN;
            } else {
                productPrice = parseFloat($('.x-product-details').find('.current-price[data-current-price]').data('current-price'));
            }

            //calculate url parameters
            var priceFrom = (priceFromMultiplier * productPrice) + priceFromAddend;
            var priceTo = (priceToMultiplier * productPrice) + priceToAddend;

            //update url
            if (priceFrom > 0 && priceTo > 0)
                url = '?price-from=' + priceFrom.toFixed(2) + '&price-to=' + priceTo.toFixed(2); 
        };

        wrpr.update = function update() {
            wrpr.loading(true);

            if (wrpr.model.HasQuickBuy) {
                Vendd.Quickbuy.addToQuickbuyList(wrpr.model.Items[0], true);
            }

            var partial = $this.data('partial');
            $this.attr('data-list-title', wrpr.model.SeoTitle);
            wrpr.model.PriceNakasText = $('.header-region.header-template-one').data('price-nakas-text') || 'Τιμή Nakas';
            wrpr.model.PriceWebText = $('.header-region.header-template-one').data('price-web-text') || 'Τιμή Web';
            wrpr.model.PricePubText = $('.header-region.header-template-one').data('price-pub-text') || 'Τιμή Εκδότη';
            var html = Vendd.Handlebars.parse(partial, wrpr.model);
            wrpr.bind(html);

            var connectedList = $(wrpr).data('list');
            if (connectedList !== undefined) {
                $('.num-of-products[data-list-count="' + connectedList + '"]').html(wrpr.model.ItemsCountText);
            }

            Vendd.MessageBus.publish(wrpr, new Vendd.Widget.Messages.BindControl($(wrpr)));

            var $boxes = $('.x-product-box[data-variantid]', wrpr);

            if (wrpr.model.Items[0][0].AlreadyInCartEnabled) {
                Vendd.MessageBus.publishAsync(wrpr, new Vendd.Cart.Messages.GetModel());
            }
            if (wrpr.model.Items[0][0].AlreadyInWishlistEnabled) {
                Vendd.MessageBus.publishAsync(wrpr, new Vendd.Wishlist.Messages.GetModel());
            }
            if (wrpr.model.Items[0][0].AlreadyInCompareListEnabled) {
                Vendd.MessageBus.publishAsync(wrpr, new Vendd.ProductCompare.Messages.GetWidgetModel());
            }

            if (lazyLoadPrices || customPrices) {
                var items = [];
                $boxes.each(function (i, el) {
                    items.push(parseInt($(el).attr('data-variantid')));
                });

                var obj = {
                    itemIds: items,
                    fetchPrices: true,
                    fetchAvailabilities: true,
                    fetchStock: true
                };
                Vendd.MessageBus.publishAsync(wrpr, new Vendd.ScrollList.Messages.GetClientProductListData(obj));
                Vendd.MessageBus.subscribe(Vendd.ScrollList.Messages.GetClientProductListDataSuccess, wrpr, wrpr.onGetClientProductListDataSuccess);
                Vendd.MessageBus.subscribe(Vendd.ScrollList.Messages.GetClientProductListDataFailure, wrpr, wrpr.onGetClientProductListDataFailure);
            }

            if (wrpr.model.Items[0][0].HasColorSelector > 0) {
                $boxes.each(function (box, i) {
                    var $box = $(this);
                    var selectedColorId = $('.js-color-selector.selected', $box).data('id');
                    $box.attr('data-selected-colorid', selectedColorId);

                    addSkuParameterInProductBox($box, selectedColorId);
                });
            }

            $('.wrapper-to-delete').remove();

            wrpr.loading(false);
        };

        wrpr.bind = function bind(html) {
            $this.html(html);

            formatPrices($this);

            var opts = {
                navigation: true,
                pagination: true,
                items: 5,
                slideSpeed: 600,
                scrollPerPage: true,
                paginationSpeed: 600,
                addClassActive: true,
                navigationText: ["<span class='icon icon-arrow-left'></span>", "<span class='icon icon-arrow-right'></span>"],
                autoPlay: false,
                lazyLoad: false,
                itemsDesktop: [1199, 5],
                itemsDesktopSmall: [959, 4],
                itemsTablet: [768, 3],
                itemsMobile: [479, 2]
            };
            $('.see-recently-container > ul', $this).owlCarousel(opts);
        };

        wrpr.getConfiguration = function () {
            return configuration;
        };

        wrpr.setModel = function (model) {
            wrpr.model = model;
        };

        wrpr.onGetClientProductListDataSuccess = function (envelope) {
            var result = JSON && JSON.parse(envelope.message.data) || $.parseJSON(envelope.message.data);
            LazyPrices(result);
            LazyAvailabilities(result);
        };

        wrpr.onGetClientProductListDataFailure = function (envelope) {
            //console.log(envelope.message.data);
        };

        var LazyPrices = function (obj) {
            $('.x-product-box[data-variantid]', wrpr).each(function (i, el) {
                var itemVariantId = parseInt($(el).attr('data-variantid'));
                var itemData = obj.Products.filter(function (a) { return a.VariantId === itemVariantId });

                if (itemData.length === 0) return;

                var prices = itemData[0].Prices.Price;
                var points = itemData[0].Prices.Points;
                var pointsGain = itemData[0].Prices.PointsGain;
                var countdownPrices = itemData[0].CountDownProperties;

                // hide all
                $('.discount-container', el).addClass('hide');
                $('.deleted-price-container', el).addClass('hide');
                $('.current-price-container', el).addClass('hide');
                $('.current-points-price-container', el).addClass('hide');
                $('.current-points-gain-container', el).addClass('hide');

                if (prices) {
                    if (prices.Discount) {
                        $('.tag.discount', el).text('-' + prices.Discount + '%');
                    }
                    if (prices.DiscountValue) {
                        $('.discount-container', el).removeClass('hide');
                        $('.discount-value', el).text(decodeEntities(prices.DiscountValue));
                    }
                    if (prices.DeletedPrice) {
                        $('.deleted-price-container', el).removeClass('hide');
                        $('.deleted-price', el).text(decodeEntities(prices.DeletedPrice));
                    } else if (countdownPrices) {
                        $('.deleted-price-container', el).removeClass('hide');
                        $('.deleted-price', el).text(decodeEntities(prices.CurrentPrice));
                    }

                    var displayedPrice = decodeEntities(prices.CurrentPrice);
                    if (countdownPrices && countdownPrices.Price) {
                        displayedPrice = countdownPrices.Price;
                    }
                    var $currentPrice = $('.current-price', el);
                    if ($enableFormatPrices) {
                        $currentPrice.html(formatPrice(displayedPrice));
                        $currentPrice.addClass('price-formatted');
                    } else {
                        $currentPrice.text(displayedPrice);
                    }
                    $('.current-price-container', el).removeClass('hide');
                }

                if (points) {
                    $('.current-points-price-container', el).removeClass('hide');
                    $('.current-points-price-container .points-price', el).text(points.PointsPrice);
                }

                if (pointsGain) {
                    $('.current-points-gain-container', el).removeClass('hide');
                    $('.current-points-gain-container .points-gain', el).text(pointsGain.TotalPointsGain);
                }

            });
        };

        var LazyAvailabilities = function (obj) {
            $('.x-product-box[data-variantid]', wrpr).each(function (i, el) {
                var itemVariantId = parseInt($(el).attr('data-variantid'));
                var itemData = obj.Products.filter(function (a) { return a.VariantId === itemVariantId });
                if (itemData.length > 0) {
                    var availability = itemData[0].Availability.AvailabilityData;
                    var cartEnabled = availability.CanBuy === true;
                    $('.availability', $(this)).addClass("availability-" + availability.AvailabilityActionId).text(availability.Name).parent('.availability-container').removeClass('hide');
                    if (cartEnabled) {
                        $('.buttons .add-to-cart', $(this)).removeClass('x-disabled');
                        $('.buttons .add-to-cart button', $(this)).removeAttr('disabled', 'disabled');
                    }
                }
            });
        };

        Vendd.MessageBus.subscribe(Vendd.LazyProductList.Messages.LazyProductListSuccess, wrpr, function (envelope) {
            var sender = envelope.message.data.sender;
            if (wrpr && sender && wrpr == sender) {
                var model = envelope.message.data.model;
                if (model.Items && model.Items.length > 0) {
                    wrpr.setModel(model);
                    wrpr.update();
                    if ($(wrpr).data("has-filter") != undefined) {
                        var connectedList = $(wrpr).data('list');
                        if (connectedList !== undefined) {
                            var $connectedFilter = $('.js-filters-wrapper[data-list="' + connectedList + '"]').first();
                            if ($connectedFilter.length > 0) {
                                Vendd.MessageBus.publishAsync($connectedFilter.get(0), new Vendd.FilterProduct.Messages.Changed(model.Filters.Filters));
                            }
                        }
                    }
                }                
            }
        });

        //keep last in component's code
        (function () {
            var defaultCallExecuted;
            function defaultCall() {
                if (Vendd.User.SessionState && !defaultCallExecuted) {
                    defaultCallExecuted = true;
                    if (hasUrlParameters && (lazyLoadPrices || customPrices || skuQueryString)) {
                        Vendd.MessageBus.subscribe(Vendd.Product.Messages.Changed, wrpr, function (envelope) {
                            wrpr.updateUrlParameters(envelope.message.data.model);
                            Vendd.MessageBus.publishAsync(wrpr, new Vendd.LazyProductList.Messages.GetLazyProductList(configuration, url));
                        });
                    } else {
                        if (hasUrlParameters)
                            wrpr.updateUrlParameters();

                        Vendd.MessageBus.publishAsync(wrpr, new Vendd.LazyProductList.Messages.GetLazyProductList(configuration, url));
                    }
                }
            }
            defaultCall();
            Vendd.MessageBus.subscribe(Vendd.User.Messages.GetSessionStateSuccess, wrpr, function (envelope) {
                defaultCall();
            });
        })();

    });

    Vendd.MessageBus.subscribe(Vendd.User.Messages.GetUserViewModelSuccess, $wrappers, function (envelope) {
        customPrices = envelope.message.data.model.HasCustomPrices;
    });

});

function reInitLazyProductLists(colorId) {

    var $lazyPds = $(".x-lazy-product-list[data-photodimensiondependent='true']");
    var configs = [], currentitemid = 0;

    if ($lazyPds.length < 1)
        return;

    if (LhApp.Context.Item.Id !== undefined && LhApp.Context.Item.Id > 0)
        currentitemid = LhApp.Context.Item.Id;

    $lazyPds.each(function () {
        var $lazypd = $(this);

        configs.push({
            configCode: $lazypd.data("code"),
            templateCode: $lazypd.data("template"),
            entityCode: $lazypd.data("entity"),
            itemId: currentitemid,
            refreshInterval: $lazypd.data("refresh-interval") === undefined ? 0 : parseInt($lazypd.data("refresh-interval")),
            nodeId: $lazypd.data("nodeid"),
            nodePath: $lazypd.data("nodepath"),
            photoDimensionId: colorId
        });
    });

    Vendd.MessageBus.publishAsync($lazyPds.get(0), new Vendd.LazyProductList.Messages.GetLazyProductList(configs[0]));
}